import shield from "../images/logo-new.png";
import shield2 from "../images/logo-new@2x.png";
import { Link } from "react-router-dom";


const navLinks = [
  { label: "Home", path: "/" },
  { label: "FAQs", path: "/faq" },
  { label: "State Recognition", path: "/state-recognition" },
  { label: "Contact Us", path: "/contact-us" },
  { label: "Terms & Conditions", path: "/terms-conditions" },
  { label: "Privacy Policy", path: "/privacy-policy" },
];
 
const Footer = () => {
  return (
    <footer className="max-w-7xl mx-auto footer bg-white border-t border-gray-200 py-6">
      <div className="hidden md:flex container mx-auto px-10 items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-shrink-0">
     <img
  width={40}
  height={40}
  src={shield}
  srcSet={`${shield} 1x, ${shield2} 2x`}
  alt="Liberty Concealed Carry"
/>
          <p className="font-acumin text-[0.72rem] text-gray-600 whitespace-nowrap">
            COPYRIGHT (c) Liberty Concealed Carry. All Rights Reserved.
          </p>
        </div>
        <nav className="flex items-center flex-wrap justify-end gap-x-4 gap-y-1">
          {navLinks.map((link) => (
            <Link
              key={link}
              to={link.path}
              className="font-acumin text-[0.72rem] text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap"
              target="_blank"
              >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="flex md:hidden flex-col items-center gap-4 px-6 w-full max-w-sm mx-auto">
        <img
  width={110}
  height={110}
  src={shield}
  srcSet={`${shield} 1x, ${shield2} 2x`}
  alt="Liberty Concealed Carry"
/>

        <nav className="grid grid-cols-3 mob-nav gap-x-6 gap-y-2 text-center w-full">
          {navLinks.map((link) => (
            <Link
              key={link}
              to={link.path}
              className="font-acumin text-[0.72rem] text-gray-600 hover:text-gray-900 transition-colors"
              target="_blank"
           >
              {link.label}
            </Link>
          ))}
        </nav>

        <p className="font-acumin text-[0.65rem] text-gray-500 text-center">
          COPYRIGHT (c) Liberty Concealed Carry.
          <br />
          All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
